import {Link} from './link';
import {EventPeriod} from './event-period';
import {Type} from 'class-transformer';

export class AgendaEvent {
  id: string;
  title: string;
  place: string;
  category: string;
  theme: string;
  @Type(() => EventPeriod)
  eventPeriod: EventPeriod;
  @Type(() => EventPeriod)
  displayPeriod: EventPeriod;
  description: string;
  color: string;
  @Type(() => Link)
  links: Array<Link>;
  tags: Array<string>;
  focus: boolean;
  visible: boolean;

}
